import { Box, Divider, Flex, Stack } from '@chakra-ui/react';
import MainCard from '../../../components/MainCard/Index';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetImpugnationDetail } from '../../../services/hooks/Impugnation/useGetImpugnationDetail';
import { useContext, useEffect } from 'react';
import { ContextAuth } from '../../../contexts/Authentication';
import { TextL, TextXL, TextXS } from '../../../components/Text/Index';
import { DefaultButton } from '../../../components/ButtonDefault/Index';

const ImpugnationDetail: React.FC = () => {
  const navigate = useNavigate();
  const impugnationId = useLocation().pathname.split('/')[4];
  const getImpugnation = useGetImpugnationDetail(impugnationId);
  const { candidate } = useContext(ContextAuth);

  useEffect(() => {
    if (!impugnationId) navigate(-1);
  }, []);

  const candidateInfo = getImpugnation?.data?.candidate;

  return (
    <MainCard title="ÁREA DO CANDIDATO - " subtitle="IMPUGNAÇÃO CONTRA EDITAL">
      <Stack px={['10px', '10px', '10px', '50px', '50px']} flexDir="column">
        <TextL fontWeight="semibold">Dados da solicitação</TextL>
        <Flex align="center" gap={1}>
          <TextXS fontWeight="bold">Processo seletivo:</TextXS>
          <TextXS>
            {getImpugnation?.data?.selective_process?.type} - {getImpugnation.data?.selective_process.name}
          </TextXS>
        </Flex>
        <Flex align="center" gap={1}>
          <TextXS fontWeight="bold">Nome completo:</TextXS>
          <TextXS>{candidate?.user?.full_name}</TextXS>
        </Flex>

        <Flex align="center" gap={1}>
          <TextXS fontWeight="bold">{candidateInfo?.is_foreign ? 'Passaporte' : 'CPF'}:</TextXS>
          <TextXS>{candidateInfo?.is_foreign ? candidateInfo.passport_number : candidateInfo?.cpf}</TextXS>
        </Flex>

        <Flex align="center" gap={1}>
          <TextXS fontWeight="bold">Data de envio:</TextXS>
          <TextXS>{getImpugnation?.data?.created_at?.br || ''}</TextXS>
        </Flex>
        <Stack>
          <TextXS fontWeight="bold">Detalhes da solicitação:</TextXS>

          <TextXS dangerouslySetInnerHTML={{ __html: getImpugnation.data?.objection || '' }}></TextXS>
        </Stack>
        {getImpugnation?.data?.selective_process?.no_reply && <Divider borderColor="gray" />}
        {getImpugnation?.data?.selective_process?.no_reply && (
          <Box>
            <TextXL>Dados da análise da solicitação</TextXL>
            <Flex gap={1}>
              <TextXS fontWeight="bold">Situação: </TextXS>
              <TextXS>{getImpugnation?.data?.status?.name}</TextXS>
            </Flex>
            {getImpugnation.data?.date_of_response_objection && (
              <Flex gap={1}>
                <TextXS fontWeight="bold">Data da análise: </TextXS>
                <TextXS>{getImpugnation?.data?.date_of_response_objection}</TextXS>
              </Flex>
            )}

            {getImpugnation.data?.response_objection && (
              <Flex flexDir={'column'} gap={0.5} alignItems="flex-start">
                <TextXS fontWeight="bold">Justificativa da situação:</TextXS>
                <TextXS
                  whiteSpace="break-spaces"
                  dangerouslySetInnerHTML={{ __html: getImpugnation.data?.response_objection || '' }}
                />
              </Flex>
            )}
          </Box>
        )}

        <Stack alignItems="flex-end">
          <DefaultButton
            onClick={() => {
              navigate(-1);
            }}
            _hover={{
              bg: '#5389ca',
            }}
            label="Voltar"
          />
        </Stack>
      </Stack>
    </MainCard>
  );
};

export default ImpugnationDetail;
